import template from './land-water.jade';
import items from '../../../enums/land-communications-location';
import itemsWaterType from '../../../enums/land-water-type';
import validation from './../../../services/validation';

export default angular
    .module('cian.addForm.aboutObjectLandWater', [])
    .directive('cianAfAboutObjectLandWater', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller(deviceService) {
            'ngInject';
            this.isMobile = deviceService.isMobile;
            this.items = items;
            this.itemsWaterType = itemsWaterType;
            this.ad.water = this.ad.water || {};

            const isOnTypes = ['border', 'location'];
            this.isOn = () => isOnTypes.includes(this.ad.water.locationType);

            this.isOnPossibleConnect = () => this.ad.water.locationType === 'no';

            this.maxCapacity = 1000;
            this.minCapacity = 0;

            this.validationCapacity = validation(this.form, 'water.capacity', {
                parse: 'Введите число',
                max: 'Допустимо не более 3 символов',
                min: 'Введите число',
            });
        },
        controllerAs: 'landWater',
        template,
    }))
    .name;
